// Main imports
import { Routes, Route, Navigate } from "react-router-dom";
import ReactGA from 'react-ga4';

// Views and components
import Footer from "./components/ui/Footer/Footer";
import Home from "./views/Home/Home";
import Locations from "./views/Locations/Locations";

// Data and context
import restaurantData from "./data/restaurantData.json";
import WebplaceProvider from "./store/webplace-provider";

// Utilities
import "./App.css";
import PrivacyPolicy from "./components/ui/privacyPolicy/PrivacyPolicy";
import { useEffect } from "react";

// GET INDEX OF NAVBAR OBJECT
const findObject = (arr, objName) => {
  const object = arr.findIndex((item) => item.title === objName);
  return object;
};

const navbarData = restaurantData.navbar_items.options;

const App = () => {
  ReactGA.initialize('G-7WG8RW2VMS');
  ReactGA.initialize('G-KL68RSVWTV')
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }, []);
  return (
    <WebplaceProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Show and redirect to Locations */}
        {navbarData[findObject(navbarData, "Locations")].shown && (
          <Route
            path={navbarData[findObject(navbarData, "Locations")].url}
            element={<Locations />}
          />
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
      <PrivacyPolicy />
    </WebplaceProvider>
  );
};

export default App;
